import React from 'react';
import styled from 'styled-components';

import { colors } from '@/constants/theme';

import { CategoryProps } from './types';

function Category({ label, icon }: CategoryProps) {
  return (
    <Component>
      <Icon>{icon}</Icon>
      <Label>{label}</Label>
    </Component>
  );
}

export default Category;

const Component = styled.div`
  position: absolute;
  left: 20px;
  bottom: 0;
  transform: translateY(50%);

  display: inline-flex;
  align-items: center;
  padding: 8px 15px;

  background: ${colors.gray100};
  border-radius: 6px;

  @media (min-width: 1400px) {
    left: 22px;
    padding: 15px 30px;
  }
`;

const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 10px;
`;

const Label = styled.span`
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: ${colors.black200};

  @media (min-width: 1400px) {
    font-size: 20px;
    line-height: 23px;
  }
`;
